(() => {
  function reducer(state, action) {
    switch (action.type) {
      case 'UPDATE':
        state.options = action.value;
        break;

      default:
        break;
    }
    return state;
  }

  window.park.app({
    container: 'job-market',
    component: 'job-market',
    reducer,
  }).then((app) => {
    window.park.ajax('https://app.stellenanzeigen.de/widget/app.asp')
      .then(result => result.xml())
      .then((document) => {
        const rubriken = Array.prototype.slice.call(document.getElementsByTagName('Rubrik'));
        const options = rubriken.map(rubrik => ({
          value: rubrik.getAttribute('Id'),
          label: rubrik.getElementsByTagName('Bezeichnung')[0].innerHTML,
        }));

        app.store.dispatch({
          type: 'UPDATE',
          value: options,
        });
      });
  });
})();



// WEBPACK FOOTER //
// ./src/widgets/job-market/job-market.js